<template>
  <div class="bg-primary">
    <a-row>
      <a-col :span="24" :xxl="{span:10, offset:7}" :xl="{span:16, offset:4}" :lg="{span:16, offset:4}"
             :md="{span:16, offset:4}">
        <a-card title="报名资料填写"
                :bordered="false"
                style="width: 100%; margin:4rem 0"
                :headStyle="{textAlign:'center', fontWeight:'bolder',fontSize:'1.5rem'}">
          <a-form-model
            ref="ruleForm"
            :model="form"
            :rules="rules"
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
          >
            <a-form-model-item ref="name" label="姓名" prop="name">
              <a-input
                v-model="form.name"
                @change="error.name=''"
                @blur="
          () => {
            $refs.name.onFieldBlur();
          }"/>
              <span class="text-danger" v-if="error.name">{{ error.name }}</span>
            </a-form-model-item>


            <a-form-model-item ref="organization" label="工作单位" prop="organization">
              <a-input
                v-model="form.organization"
                @change="error.organization=''"
                @blur="
          () => {
            $refs.organization.onFieldBlur();
          }
        "
              />
              <span class="text-danger" v-if="error.organization">{{ error.organization }}</span>
            </a-form-model-item>
            <a-form-model-item ref="position" label="单位职务" prop="position">
              <a-input
                v-model="form.position"
                @change="error.position=''"
                @blur="
          () => {
            $refs.position.onFieldBlur();
          }"/>
              <span class="text-danger" v-if="error.position">{{ error.position }}</span>
            </a-form-model-item>


            <a-form-model-item ref="phone" label="手机号" prop="phone">
              <a-input
                @change="error.phone=''"
                v-model="form.phone"
                @blur="
          () => {
            $refs.phone.onFieldBlur();
          }"/>

              <span class="text-danger" v-if="error.phone">{{ error.phone }}</span>
              <span class="text-danger" v-if="error.error">{{ error.error }}</span>
            </a-form-model-item>


            <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }" style="text-align: center">
              <a-button type="primary" @click="onSubmit">
                马上报名
              </a-button>
              <a-button style="margin-left: 10px;" @click="resetForm">
                为他人报名
              </a-button>
            </a-form-model-item>

          </a-form-model>
        </a-card>
      </a-col>
    </a-row>

    <a-modal v-model="showSuccess" title="报名成功" @ok="handleOk" okText="返回活动" cancelText="继续报名">
      您已成功报名！
    </a-modal>


  </div>

</template>
<script>
import {createRegistration, createUserPerson, getUserOrganization, getUserPerson} from "../../api/api";
import cookie from "../../../static/js/cookie";
import {filterUnderLine} from "../../../static/js/util";

export default {
  name: "Apply",
  props: {
    id: ''
  },
  data() {
    return {
      labelCol: {span: 6},
      showSuccess: false,

      wrapperCol: {span: 14},
      form: {
        name: '',
        phone: '',
        organization: '',
        position: '职员'
      },
      error: {
        error: '',
        name: '',
        phone: '',
        organization: '',
        position: ''
      },
      rules: {
        name: [
          {required: true, message: '姓名不能为空', trigger: 'blur'},
          {min: 2, max: 20, message: '姓名位2-20个字符', trigger: 'blur'},
        ],
        organization: [
          {required: true, message: '工作单位不能为空', trigger: 'blur'},
          {min: 2, max: 20, message: '工作单位2-20个字符', trigger: 'blur'},
        ],
        position: [
          {required: true, message: '单位职务不能为空', trigger: 'blur'},
        ],

        phone: [
          {required: true, message: '手机号不能为空', trigger: 'blur'},
          {min: 11, max: 11, message: '手机号错误', trigger: 'blur'}
        ],
      },
    };
  },
  methods: {
    handleOk() {
      this.$router.push({name: 'activityInfo', params: {id: this.id}})
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {


        if (valid) {

          let params = {
            name: this.form.name,
            phone: this.form.phone,
            organization: this.form.organization,
            position: this.form.position,
            user: this.$store.getters.userInfo.id,
            activity: this.id
          }

          createRegistration(params)
            .then(res => {
              if (res.statusText === "Created" || res.status === 201) {
                this.showSuccess = true
              }
            }).catch(err => {
            if ('non_field_errors' in err) {
              this.error.error = err['non_field_errors'][0]
              if ("name" in error) {
                that.error.name = error.name[0];
              }

              if ("phone" in error) {
                that.error.phone = error.phone[0];
              }
              if ("organization" in error) {
                that.error.organization = error.organization[0];
              }

              if ("position" in error) {
                that.error.position = error.position[0];
              }
            }
          })
        } else {
          console.log('报名失败')
        }
      })
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },

  },
  mounted() {
    let man = ''
    console.log(this.$store.getters.userInfo)
    if (this.$store.getters.userInfo.part === 'O') {
      getUserOrganization(this.$store.getters.userInfo.uid)
      man = filterUnderLine(res.data)
      this.form.name = man.linkman
      this.form.phone = man.linkphone
      this.form.organization = man.name
      this.form.position = man.linkposition
    } else {
      getUserPerson(this.$store.getters.userInfo.uid)
        .then(res => {
          man = filterUnderLine(res.data)
          this.form.name = man.name
          this.form.phone = man.phone
          this.form.organization = man.organization
          this.form.position = man.position
        })
    }


  }
};
</script>
<style scoped>
a:hover {
  color: rebeccapurple;
}
</style>



// WEBPACK FOOTER //
// src/components/content/Apply.vue